import React, { Component } from 'react';
import { Container, Col, Row} from 'reactstrap';
import { HashLink } from 'react-router-hash-link';

import Logo from '../ui-elements/Logo';
import SourceList from '../ui-elements/SourceList';


class Features extends Component {

  constructor(props){
    super(props);
    this.state = {
      quellen: false,
    };
  }
  showQuellen = () => {
    this.setState({
      quellen: true
    });
  }
  toggleQuellen = () => {
    this.setState({
      quellen: !this.state.quellen
    });
  }

  render() {
    return (
    <Container fluid className="bg-secondary">
      <Container>

        <Row className='justify-content-center py-5 text-left' style={{
          position: 'relative',
          backgroundImage: 'url(/imgs/divider_shadow.png)',
          backgroundSize: '100% auto',
          backgroundPosition: 'center bottom',
          backgroundRepeat: 'no-repeat',
        }}>
          <div className='d-flex' style={{minHeight: '50vh'}}>
            <Col xs="12" md="6" className="mx-auto align-self-center text-center py-5">
              <p className="text-primary d-block mb-3"><strong>paul</strong> open search</p>
              <h3 className="text-white mx-4">Die Plattform für politische Hintergründe</h3>
              <p className="lead text-white mb-5">Wir bündeln die Inhalte verschiedenster politischer Organisationen um <strong>verschiedene Perspektiven</strong> auf gesellschaftliche Themen zu ermöglichen.</p>
              <HashLink to="/about#top" className="btn btn-primary shadow-sm">Warum wir das machen</HashLink>
            </Col>
          </div>
        </Row>

        <Row className='justify-content-center py-5 text-left' style={{
          position: 'relative',
          backgroundImage: 'url(/imgs/divider_shadow.png)',
          backgroundSize: '100% auto',
          backgroundPosition: 'center bottom',
          backgroundRepeat: 'no-repeat'
        }}>
            <Col xs="12" md="5" className="align-self-center text-center order-1 order-md-0">
              <div className="mr-0 mr-md-5" style={{position: 'relative'}}>
                <SourceList className="shadow triangle-bottom-center-white" legend bg="secondary" />
                <div className="text-center" style={{ transform: 'translateY(-15px)' }}>
                  <Logo size="md" className="mt-4" link={false} />
                </div>
              </div>
            </Col>
            <Col xs="12" md="5" className="align-self-center order-0 order-md-1 text-center text-md-left">
              <h4 className="text-white">Wissen aus erster Hand</h4>
              <p className="text-white mb-5">Die Inhalte stammen von <strong>Profis</strong> aus allen politischen Richtungen. Sie bieten belastbare Informationen und <strong>direkte Einblicke</strong> in das politische Geschehen.</p>
              <HashLink to="/content#top" className="btn btn-light text-secondary mb-5 shadow-sm">Mehr zu den Inhalten</HashLink>
            </Col>
          </Row>

          <Row className="text-center pt-3">
            <Col>
              <small className="text-white">Unsere offiziellen Medienpartner</small>
            </Col>
          </Row>
          <Row className='justify-content-center text-center pt-4 pb-5' style={{
            position: 'relative',
            backgroundImage: 'url(/imgs/divider_shadow.png)',
            backgroundSize: '100% auto',
            backgroundPosition: 'center bottom',
            backgroundRepeat: 'no-repeat'
          }}>
            <Col xs="12" className="align-self-center px-5">
              <img src="/imgs/medienpartner/logo_100x80_lemond_white.png" alt="Le Monde Diplomatique" className="img-fluid mx-2 mx-md-3" style={{maxWidth: 100, height: 'auto', width: '25%'}}/>
              <img src="/imgs/medienpartner/logo_100x80_blaetter_white.png" alt="Blätter für deutsche und internationale Politik" className="img-fluid mx-2 mx-md-3" style={{maxWidth: 100, height: 'auto', width: '25%'}}/>
              <img src="/imgs/medienpartner/logo_100x80_agora_white.png" alt="agora42" className="img-fluid mx-2 mx-md-3" style={{maxWidth: 100, height: 'auto', width: '25%'}}/>
            </Col>
          </Row>

    </Container>
  </Container>
  )};
}


export default Features;



// WEBPACK FOOTER //
// ./src/components/Landing/Features.js